import React from 'react'
import Management from './Management/page'

export function ManagementWithContext() {
  return <Management />
}
